import { ErrorCodes } from './errorCodes';
import { ErrorHandlerOptions } from '../error.interface';
import { ERROR_MSGS } from '../../constants/registration/error.messages';

interface E403 extends ErrorHandlerOptions {}

export const handle403Error = ({ error, showError, action }: E403) => {
  const errorCode = error?.data?.code;

  switch (errorCode) {
    case ErrorCodes.EMAIL_NOT_VERIFIED:
      action?.(error);
      break;
    // feature for future
    // case ErrorCodes.ACCOUNT_BLOCKED:
    //   alert(ErrorCodes.ACCOUNT_BLOCKED); // Or navigate to a support page
    //   break;
    // case ErrorCodes.INSUFFICIENT_PERMISSIONS:
    //   alert(ErrorCodes.INSUFFICIENT_PERMISSIONS); // Or redirect to a permissions request page
    //   break;
    // case ErrorCodes.SESSION_EXPIRED:
    //   alert(ErrorCodes.SESSION_EXPIRED);
    //   navigate('/login');
    //   break;
    // case ErrorCodes.GENERAL_403:
    //   alert(ErrorCodes.GENERAL_403); // General 403 error message
    //   break;
    default:
      showError?.(ERROR_MSGS.UNKNOWN_ERROR);
      break;
  }
};
